package org.hs_soft.runmynesto.domain.config.language

object  ItalianoStrings : StringResources {
    override val given = "Dato"
    override val billNumberFrom: String = "Numero Fattura (da)"
    override val BillNumberTo: String = "Numero Fattura (a)"
    override val totalTo: String = "Totale (a)"
    override val totalFrom: String = "Totale (da)"
    override val receiptNo = "N. scontrino"
    override val receiptsList = "Lista scontrini"
    override val dragColumnHint="Trascina qui un'intestazione di colonna per raggruppare per questa colonna"
    override val selectCashRegisters="Seleziona casse"
    override val priceCategory = "Categoria di prezzo"
    override val fixedProducts = "Prodotti fissi"
    override val gang="Gruppo"
    override val addNewSelection="Aggiungi nuova selezione"
    override val quantity = "Quantità"
    override val fixedQuantity = "Quantità Fissa"
    override val maxQuantity = "Quantità Massima"
    override val minQuantity = "Quantità Min"
    override val isTheMenuName = "È il nome del menu"
    override val selection = "Selezione"
    override val addNewPrice="Aggiungi nuovo prezzo"
    override val endTime="Ora di fine"
    override val individualPrice = "Prezzo Individuale"
    override val numberOfButtons="Numero di pulsanti"
    override val sorting = "Ordinamento"
    override val sortingAutoByName = "Ordinato per nome"
    override val sortingAutoByNumber = "Ordinato per numero"
    override val sortingManual = "Manuale"
    override val doYouWantToRemove="Vuoi rimuovere"
    override val error = "Errore"
    override val availableEveryWhere: String = "Disponibile Ovunque"
    override val singleRightDoor: String = "Porta singola destra"
    override val singleLeftDoor: String = "Porta singola sinistra"
    override val horizontalWall = "Muro Orizzontale"
    override val verticalWall = "Muro Verticale"
    override val horizontalWindow = "Finestra Orizzontale"
    override val verticalWindow = "Finestra Verticale"
    override val squaredColumn = "Colonna Quadrata"
    override val roundedColumn = "Colonna Rotonda"
    override val singleDoor = "Porta Singola"
    override val doubleDoors = "Porte Doppie"
    override val chair = "Sedia"
    override val barStool = "Sgabello da Bar"
    override val armChair = "Poltrona"
    override val twoSeaterSofa = "Divano a Due Posti"
    override val threeSeaterSofa = "Divano a Tre Posti"
    override val cocktailBarTable = "Tavolo da Cocktail/Bar"
    override val tree = "Albero"
    override val bush = "Cespuglio"
    override val plant = "Pianta"
    override val exit = "Uscita"
    override val wc = "WC"
    override val newRoomName = "Nuovo nome della stanza"
    override val floors = "Piani"
    override val multiFactorAuthentication="Autenticazione a Più Fattori"
    override val signIn="Accedi"
    override val enterLoginRequiredData="Inserisci i dati richiesti per accedere al sistema."
    override val verificationInfo="Il tuo account è protetto mediante Autenticazione a Più Fattori (MFA). Inserisci il seguente codice di autenticazione per completare l'accesso"
    override val noData="Nessun Dato"
    override val shopName="Nome del Negozio"
    override val edit="Modifica"
    override val price3="Prezzo 3"
    override val altName="Nome alternativo articolo"
    override val salesUnit="Unità di vendita"
    override val presetRoom="Sala predefinita"
    override val priceShowOnKitchenReceipt="Mostra prezzo sulla ricevuta di cucina"
    override val printDishesOfTheNextCourse="Stampa piatti della portata successiva"
    override val store="Negozio"
    override val poiId = "ID POI"
    override val liveEndpointUrlPrefix = "Prefisso URL Endpoint Live"
    override val apiKey = "Chiave API"
    override val applicationKey = "Chiave Applicazione"
    override val roomId = "ID Sala"
    override val virtualTerminalId = "ID Terminale Virtuale"
    override val terminalId = "ID Terminale"
    override val userId = "ID Utente"
    override val posID="ID POS"
    override val tId="TID"
    override val hardware="Hardware"
    override val creditCardLink="Collegamento carta di credito"
    override val openCashDrawerAfterEFTTransaction="Apri cassetto dopo transazione EFT"
    override val tcpIP="TCP/IP"
    override val terminal="Terminale"
    override val tse="TSE"
    override val eftTerminal="Terminale EFT"
    override val activate="Attiva"
    override val adminPin="PIN Admin"
    override val adminPUK="PUK Admin"
    override val tseType="Tipo TSE"
    override val printQRCode="Stampa QR-Code"
    override val timeadminPin="PIN Timeadmin"
    override val timeadminPUK="PUK Timeadmin"
    override val tseLocation="Posizione TSE"
    override val tseInformation="Informazioni TSE"
    override val activeKitchenPrinter="Stampante cucina attiva"
    override val printReceiptAfterCompletion="Stampa ricevuta dopo completamento"
    override val printKitchenOnlyForTables="Stampa cucina solo per tavoli"
    override val kitchenLocations="Posizioni cucina"
    override val topEdgeCm="Margine superiore (cm)"
    override val separateCakeToppings="Guarnizioni torta separate"
    override val tableShift="Spostamento tavolo"
    override val uploadImgInfoSize="256x256 px"
    override val apaleoPMSSubAccounts="Sottoconti Apaleo PMS"
    override val uploadImgInfoType="JPG, PNG"
    override val uploadManually="Carica manualmente"
    override val generateUsingAI="Genera con IA"
    override val updatingApaleoPaymentWithCashRegister="Aggiornamento metodi di pagamento Apaleo con i metodi di pagamento del registratore di cassa"
    override val selectSalesGroupsForApaleoSubaccounts="Seleziona gruppi di vendita per sottoconti Apaleo"
    override val clientId="ID Cliente"
    override val clientSecret="Segreto Cliente"
    override val export="Esporta"
    override val noValidIPAddress="Indirizzo IP non valido"
    override val apaleoPMSProperty="Proprietà Apaleo PMS"
    override val port="Porta"
    override val pmsType="Tipo PMS"
    override val printReceiptAutomatically="Stampa ricevuta automaticamente"
    override val transferAllDocuments="Trasferimento di tutti i documenti"
    override val pms="PMS"
    override val createCard="Crea carta"
    override val loading="Caricamento..."
    override val selected="Selezionato"
    override val category="Categoria"
    override val turnoverGroup="Gruppo di Fatturato"
    override val ingredients="Ingredienti"
    override val productNumber="Numero Prodotto"
    override val alcoholic="Alcolico"
    override val vegan="Vegano"
    override val vegetarian="Vegetariano"
    override val disable="Disabilitato"
    override val protel: String = "Protel"
    override val apaleo: String = "Apaleo"
    
    // Table types
    override val squaredTable: String = "Tavolo Quadrato"
    override val roundTable: String = "Tavolo Rotondo"
    
    // Element actions
    override val addElement: String = "Aggiungi Elemento"
    override val editElement: String = "Modifica Elemento"
    
    // Interior design elements
    override val structure: String = "Struttura"
    override val furniture: String = "Mobili"
    override val interiorDecoration: String = "Decorazione d'Interni"
    override val indicators: String = "Indicatori"
    
    // Form inputs
    override val enterCompanyName: String = "Inserisci il nome dell'azienda"
    override val country: String = "Paese"
    override val kitchenStations: String = "Stazioni di Cucina"
    override val writeNewRoomNameToAdd: String = "Scrivi il nome della nuova stanza da aggiungere"
    
    override val lookingForAnswer="Cercando una risposta..."
    override val tel="Tel"
    override val shopsExclusiveTemplate="Template esclusivo negozi"
    override val position="Posizione"
    override val comparedToPreviousWeek="Rispetto ai ricavi della settimana scorsa, stesso giorno"
    override val printerLocations="Posizioni stampanti"
    override val setDefaultValuesForNewCustomer="Imposta valori predefiniti per nuovo cliente"
    override val paymentMethods="Metodi di Pagamento"
    override val save="Salva"
    override val disableContentOnDevice="Disabilitare contenuto sul dispositivo"
    override val transferSettingFromCashRegister="Trasferimento impostazioni dal registratore di cassa"
    override val androidSerialNumber="Numero seriale Android"
    override val cashRegisterType="Tipo registratore di cassa"
    override val addNewBusinessOfficeDE="Aggiungi nuovo ufficio commerciale"
    override val addNewRegionDE="Aggiungi nuova regione"
    override val addNewBranchDE="Aggiungi nuova filiale"
    override val addNewCashRegisterDE="Aggiungi nuovo registratore di cassa"
    override val addNewDevice="Aggiungi nuovo dispositivo"
    override val vatNormal="IVA normale"
    override val vatReduced="IVA ridotta"
    override val vatFree="Senza IVA"
    override val vatSpecial="IVA speciale"
    override val delete="Elimina"
    override val copy="Copia"
    override val tableNumber="Numero Tavolo"
    override val enterTableNumber="Inserisci il numero del tavolo"
    override val seats="Posti"
    override val restoMate="RestoMate"
    override val restoMateDescription="Il tuo compagno di ristorante potenziato dall'IA"
    override val dataAssistantDatabaseLoadingTitle="Il tuo database è in caricamento..."
    override val dataLoadingProgressCategoryImportTitle="Le categorie si stanno caricando..."
    override val dataLoadingProgressMenuCardImportTitle="Il tuo Menu è stato caricato"
    override val editFloor="Modifica piano"
    override val list="Lista"
    override val tiles="Riquadri"
    override val desktopWaiter="Cameriere Desktop"
    override val mobileWaiter="Cameriere Mobile"
    override val listingLayout="Layout Listino"
    override val device="Dispositivo"
    override val cash="Contanti"
    override val eft="EFT"
    override val tips="Mance"
    override val revenueGuest="Ricavo/Ospite"
    override val totalRevenue="Ricavo totale"
    override val analizeQuestionProcess="Analizzando la domanda..."
    override val generateSQLProcess="Generazione SQL..."
    override val formatAnswerProcess="Formattazione SQL..."
    override val createFilesProcess="Creazione file..."
    override val uploadFilesProcess="Caricamento file..."
    override val generateMenuCardProcess="Generazione menu..."
    override val clearMenuCardProcess="Pulizia menu..."
    override val prepareResultProcess="Preparazione risultato..."
    override val menuCardProgressMessage="passaggi completati"
    override val menuCardSelectFilesMessages="Scegli file (.pdf, .png, .jpg) non più grandi di 3MB"
    override val filesChosen="file scelti"
    override val uploaded="caricato"
    override val generalInfo="Informazioni Generali"
    override val download="Scarica"
    override val doYouWantToRemoveThisFloor="Vuoi rimuovere questo piano?"
    override val doYouWantToRemoveThisRoom="Vuoi rimuovere questa sala?"
    override val floorNumber="Numero piano"
    override val addNewFloor="Aggiungi nuovo piano"
    override val wall="Muro"
    override val floor="Piano"
    override val show3D="Mostra 3D"
    override val addFloor="Aggiungi Piano"
    override val interiorDecor="Arredamento Interno"
    override val add="Aggiungi"
    override val table="Tavolo"
    override val roomName="Nome Sala"
    override val projectName="Nome Progetto"
    override val restaurantManager="Gestore Ristorante"
    override val addNewGroup="Aggiungi nuovo gruppo"
    override val editGroup="Modifica Gruppo"
    override val shopaffiliation="Affiliazione negozio"
    override val dateInterval="Intervallo date"
    override val selfCheckout_1080_1920="Self-Checkout (1024*600)"
    override val standard_1024_600="Standard (1024*600)"
    override val addNewMedia="Aggiungi nuovo media"
    override val refreshTime="Tempo di aggiornamento"
    override val chooseAnArticle="Scegli un Articolo"
    override val advertisingDuringTyping="Pubblicità durante la digitazione"
    override val fullDisplayAdvertising="Pubblicità a schermo intero"
    override val stayActive="Rimani Attivo"
    override val media="Media"
    override val mediaCenter="Centro Media"
    override val actions="Azioni"
    override val disableCompletion="Disabilita completamento"
    override val reason="Motivo"
    override val deactivateDailyClosing="Disattiva chiusura giornaliera"
    override val group="Gruppo"
    override val groupByDateShop="Raggruppa per Data/Negozio"
    override val groupByShop="Raggruppa per Negozio"
    override val groupByDate="Raggruppa per Data"
    override val inTotal="In Totale"
    override val printFinancialStatements="Stampa rendiconti finanziari"
    override val selectedItem="Elemento Selezionato"
    override val exportExcel="Excel"
    override val price="Prezzo"
    override val percentSign="%"
    override val code="Codice"
    override val productDateShop="Prodotto-Data-Negozio"
    override val productDate="Prodotto-Data"
    override val dateProduct="Data-Prodotto"
    override val productShop="Prodotto-Negozio"
    override val shopProduct="Negozio-Prodotto"
    override val lastSale="Ultima Vendita"
    override val weight="Peso"
    override val firstSale="Prima Vendita"
    override val groupedBy="Raggruppato per"
    override val notCancelled="Non Annullato"
    override val cancelled="Annullato"
    override val userName="Nome utente"
    override val total="Totale"
    override val cancellation="Annullamento"
    override val pdf="PDF"
    override val abcStatistic="Statistica ABC"
    override val billSearch="Ricerca Fattura"
    override val setting="Impostazione"
    override val statistic="Statistica"
    override val threeWeeksAgo="3 settimane fa"
    override val twoWeeksAgo="2 settimane fa"
    override val lastWeek="Settimana scorsa"
    override val compare="Confronta"
    override val sales="Vendite"
    override val allTheRegions="Tutte le regioni"
    override val clients="Clienti"
    override val workingHours="Ore lavorative"
    override val hourlyRate="Tariffa oraria"
    override val averageCheck="Controllo medio"
    override val turnOver="Fatturato"
    override val euro="€"
    override val cashRegisters="Registratori di cassa"
    override val restaurantsOf="Ristoranti di"
    override val dashboard="Dashboard"
    override val backgroundColor="Colore sfondo"
    override val fakeLatestPurchasesAndMore="https://shortlink.com/**********"
    override val fakeQRCode="0000-0000-0000-0000"
    override val fakeCustomerNumber="0000001"
    override val incomeAndExpanse="Entrate e Spese"
    override val cashBookAndCoupons="Libro cassa e Coupon"
    override val credit="Credito"
    override val pressets="Preimpostazioni"
    override val apply="Applica"
    override val amountCHF="Importo CHF"
    override val amount="Importo"
    override val difference="Differenza"
    override val cashDelivery="Consegna contanti"
    override val IsnInCHF="È in CHF"
    override val course="Corso"
    override val lst="lst"
    override val currency="Valuta"
    override val reduction="Riduzione"
    override val freeVat="IVA Gratuita"
    override val empty="Vuoto"
    override val reports="Rapporti"
    override val FROM_DATE="Da Data"
    override val GROUP="gruppo"
    override val BALANCE="saldo"
    override val BOOKING_MODE="modalità prenotazione"
    override val UNTIL_DATE="Fino a Data"
    override val CHECKOUT="Pagamento"
    override val CREDIT="Credito"
    override val POINTS="punti"
    override val CHECKOUT_DATE="data pagamento"
    override val DESIGNATION="Designazione"
    override val DOCUMENT_NUMBER="numero documento"
    override val BURDEN="Onere"
    override val POINTS_BALANCE="saldo punti"
    override val CASH_REGISTER_TIME="ora registratore di cassa"
    override val cashRegisterName="Nome Registratore di Cassa"
    override val selectDesiredColumns="Seleziona le colonne desiderate"
    override val transaction="Transazioni"
    override val addNewCustomerCard="Aggiungi nuova carta cliente"
    override val digitalCustomerCard="Carta Cliente Digitale"
    override val rfidCustomerCard="Carta Cliente RFID"
    override val zeroSetting="Nessuna Impostazione"
    override val none="Nessuno"
    override val discountGroup1="Gruppo Sconto 1"
    override val discountGroup2="Gruppo Sconto 2"
    override val discountGroup3="Gruppo Sconto 3"
    override val discountGroup4="Gruppo Sconto 4"
    override val discountGroup5="Gruppo Sconto 5"
    override val discountGroup6="Gruppo Sconto 6"
    override val discountGroup7="Gruppo Sconto 7"
    override val discountGroup8="Gruppo Sconto 8"
    override val discountGroup9="Gruppo Sconto 9"
    override val discountGroup10="Gruppo Sconto 10"
    override val discountGroup11="Gruppo Sconto 11"
    override val discountGroup12="Gruppo Sconto 12"
    override val discountGroup13="Gruppo Sconto 13"
    override val discountGroup14="Gruppo Sconto 14"
    override val discountGroup15="Gruppo Sconto 15"
    override val discountGroup16="Gruppo Sconto 16"
    override val discountGroup17="Gruppo Sconto 17"
    override val discountGroup18="Gruppo Sconto 18"
    override val discountGroup19="Gruppo Sconto 19"
    override val discountGroup20="Gruppo Sconto 20"
    override val inHouseCard="Carta Interna"
    override val loyaltyCard="Carta Fedeltà"
    override val clientName="Nome Cliente"
    override val salutation="Saluto"
    override val resetBooking="Reimposta Prenotazione"
    override val cardHolder="Titolare Carta"
    override val loadLabels="Carica Etichette"
    override val loadMaps="Carica Mappe"
    override val loadingLabeling="Caricamento/Etichettatura"
    override val labelingWorkCards="Etichettatura Carte Lavoro"
    override val loadingWorkCards="Caricamento Carte Lavoro"
    override val createCustomerCard="Crea Carta Cliente"
    override val until="Fino a"
    override val from="Da"
    override val loyaltyCards="Carte Fedeltà"
    override val calculate="Calcolare"
    override val end="Fine"
    override val start="Inizio"
    override val period="Periodo"
    override val January="Gennaio"
    override val February="Febbraio"
    override val March="Marzo"
    override val April="Aprile"
    override val May="Maggio"
    override val June="Giugno"
    override val July="Luglio"
    override val August="Agosto"
    override val September="Settembre"
    override val October="Ottobre"
    override val November="Novembre"
    override val December="Dicembre"
    override val fourQuarters="T4"
    override val threeQuarters="T3"
    override val twoQuarters="T2"
    override val oneQuarter="T1"
    override val twoHalfAYear="2° METÀ"
    override val oneHalfAYear="1° METÀ"
    override val next="Avanti"
    override val previous="Precedente"
    override val previousWeek="Settimana Precedente"
    override val thisWeek="Questa Settimana"
    override val yesterday="Ieri"
    override val today="Oggi"
    override val rfid="RFID"
    override val barcode="Codice a Barre"
    override val collectPointsWhenCharged="Raccogli punti solo quando addebitato"
    override val cardCanOnlyBeChargedByCash="La carta può essere ricaricata solo con contanti"
    override val grantDiscountOnNetItems="Concedi sconto anche sugli articoli netti"
    override val grantDiscountWhenCharged="Concedi sconto solo quando addebitato"
    override val discountNumber="N° Sconto"
    override val discountGLWithPercent="Sconto GL, %"
    override val discountWithPercent="Sconto, %"
    override val debitCard="Carta di Debito"
    override val cardType="Tipo di Carta"
    override val art="Arte"
    override val owner="Proprietario"
    override val email="Email"
    override val telephone="Telefono"
    override val firstName="Nome"
    override val address="Indirizzo"
    override val zipCity="CAP"
    override val cardLimit="Limite carta"
    override val dailyLimit="Limite giornaliero"
    override val card="Carta"
    override val cardNumber="Numero carta"
    override val lastUsed="Ultimo utilizzo"
    override val internetAccessCode="Codice accesso Internet"
    override val series="Serie"
    override val customerCards="Carte clienti"
    override val points="Punti"
    override val ipAddress="Indirizzo IP"
    override val kitchenPrinterSerialNumber="Numero seriale stampante cucina"
    override val addCakeDisplay="Aggiungi display torte"
    override val serialNumber="Numero seriale"
    override val logout="Disconnetti"
    override val backToAdmin="Torna alla modalità amministratore"
    override val myProfile="Il mio profilo"
    override val globalSearch="Ricerca globale"
    override val noItemToDisplay="Nessun elemento da visualizzare"
    override val standardInBracket="<Standard>"
    override val mwstNormal="IVA-Normale"
    override val salesVolume="Vendite"
    override val time="Ora"
    override val date="Data"
    override val closingReports="Rapporti di Chiusura"
    override val standardWithoutPrinting="Standard senza stampa"
    override val withCashReportAndCountProtocol="Con rapporto di cassa e protocollo di conteggio"
    override val withoutCash="Senza contanti"
    override val standard="Standard"
    override val withCashReport="Con rapporto di cassa"
    override val vatRateSelection="Selezione Aliquota IVA"
    override val specialVat="IVA Speciale"
    override val reducedVat="IVA Ridotta"
    override val normalVat="IVA Normale"
    override val office="Ufficio"
    override val priceLevel="Livello Prezzo"
    override val region="Regione"
    override val priceLevelInHouseButton="Pulsante Livello Prezzo Interno"
    override val branch="Filiale"
    override val mode="Modalità"
    override val cashierName="Nome Cassiere"
    override val copyForWaiter="Copia per cameriere"
    override val printer="Stampante"
    override val receiptCopy="Copia Ricevuta"
    override val fromAmount="Da Importo"
    override val variable="Variabile"
    override val inTheHouse="Nella-Casa"
    override val degree="Grado"
    override val activateEmployeeCompletion="Attiva completamento dipendenti"
    override val degreeType="Tipo di Grado"
    override val close="Chiudi"
    override val previewForAppleWallet="Anteprima per Apple Wallet"
    override val latestPurchasesAndMore="Ultimi acquisti e altro"
    override val phone="Telefono"
    override val qrCode="Codice QR"
    override val customerName="Nome Cliente"
    override val customerNumber="Numero Cliente"
    override val cardName="Nome Carta"
    override val specialDiscountTier="Livello Sconto Speciale"
    override val discountTier="Livello Sconto"
    override val aboutTheCard="Maggiori informazioni sulla carta sul retro!"
    override val cashAssistCard="Carta Cash Assist"
    override val balance="Saldo"
    override val customerCard="Carta Cliente"
    override val previewForGoogleWallet="Anteprima per Google Wallet"
    override val cardPreview="Anteprima carta"
    override val cardInfoPreview="Anteprima info carta"
    override val cashRegisterConfig="Configurazione Registratore di Cassa"
    override val menuCardImport="Importazione Menu"
    override val advertisingText="Testo Pubblicitario"
    override val optionalTwo="Opzionale Due"
    override val optionalOne="Opzionale Uno"
    override val vatNumber="Numero IVA"
    override val addition="Aggiunta"
    override val mfaCode="Codice-MFA"
    override val incomeExpanses="Ent/Spese"
    override val incomeExpanses1="Ent/Spese 1"
    override val incomeExpanses2="Ent/Spese 2"
    override val incomeExpanses3="Ent/Spese 3"
    override val incomeExpanses4="Ent/Spese 4"
    override val incomeExpanses5="Ent/Spese 5"
    override val name1="Nome 1"
    override val name2="Nome 2"
    override val name3="Nome 3"
    override val name4="Nome 4"
    override val name5="Nome 5"
    override val name6="Nome 6"
    override val name7="Nome 7"
    override val name8="Nome 8"
    override val name9="Nome 9"
    override val name10="Nome 10"
    override val creditCard="Carta di Credito"
    override val cashFlow="Flusso di Cassa"
    override val companyLogo="Logo Azienda"
    override val colorIsMissing="Colore mancante"
    override val titleFontColor="Colore font titolo"
    override val fontColor="Colore Font"
    override val preview="Anteprima"
    override val wideCompanyLogo="Logo azienda largo"
    override val heroImage="Immagine hero"
    override val googleWallet="Google Wallet"
    override val appleWallet="Apple Wallet"
    override val website="Sito Web"
    override val titleWebsite="Titolo Sito Web"
    override val telephoneNumber="Numero Telefono"
    override val titleContact="Titolo Contatto"
    override val title2="Titolo 2"
    override val titleField2="Titolo Campo 2"
    override val title1="Titolo 1"
    override val titleField1="Titolo Campo 1"
    override val description="Descrizione"
    override val emailCompany="Email Azienda"
    override val activeCustomersCard="Le carte clienti mobili sono attive"
    override val virtualCard="Carta Virtuale"
    override val addNewLocation="Aggiungi nuova posizione"
    override val uploadFromPc="Carica da Locale"
    override val prompt="Prompt"
    override val question="La Tua Domanda"
    override val newImage="Nuova Immagine"
    override val newMenuCard="Nuovo Menu"
    override val dataAssistant="Assistente Dati"
    override val price2="Prezzo 2"
    override val price1="Prezzo 1"
    override val numberDot="N°."
    override val addNewItem="Aggiungi nuovo elemento"
    override val variant1="Variante 1"
    override val variant2="Variante 2"
    override val variant3="Variante 3"
    override val variant4="Variante 4"
    override val variant5="Variante 5"
    override val variant6="Variante 6"
    override val variant7="Variante 7"
    override val variant8="Variante 8"
    override val variant9="Variante 9"
    override val variant10="Variante 10"
    override val kitchenInformation="Informazioni Cucina"
    override val items="Elementi"
    override val addNewSaleGroup="Aggiungi nuovo gruppo vendita"
    override val submit="Invia"
    override val inactiveItems="Elementi Inattivi"
    override val activeItems="Elementi Attivi"
    override val allItems="Tutti gli Elementi"
    override val individualFilter="Filtro Individuale"
    override val creatingNewProduct="Creazione di un nuovo prodotto"
    override val numberOrNameIsWrong="Numero o nome errato."
    override val products="Prodotti"
    override val companyProfile="Profilo Azienda"
    override val imageAiDialogWaitingMsg="Il processo potrebbe richiedere più di 30 s"
    override val menuCardAIDialogWaitingMsg="Il processo potrebbe richiedere più di 3 m"
    override val generate="Genera"
    override val hint="Suggerimento"
    override val allDays="Tutti i Giorni"
    override val mondayFull="Lunedì"
    override val tuesdayFull="Martedì"
    override val wednesdayFull="Mercoledì"
    override val thursdayFull="Giovedì"
    override val fridayFull="Venerdì"
    override val saturdayFull="Sabato"
    override val sundayFull="Domenica"
    override val selectDays="Seleziona Giorni"
    override val color="Colore"
    override val changesValidFrom="Modifiche Valide Da"
    override val surchargePercent="Supplemento %"
    override val away="Da Asporto"
    override val surchargeAmount="Importo Supplemento"
    override val priceLevels="Livelli Prezzo"
    override val surchargeInHouse="Supplemento Interno"
    override val contain="Contiene"
    override val allergens="Allergeni"
    override val deliveryTimeInDays="Giorni di Consegna"
    override val minimumOrder="Ordine Minimo"
    override val maximumOrder="Ordine Massimo"
    override val vat="IVA"
    override val printKitchenReceiptIfInfoSelected="Stampa ricevuta di cucina solo quando l'informazione di cucina è selezionata"
    override val printKitchenReceiptIfInHouseActive="Stampa ricevuta di cucina solo quando il pulsante In-Casa è attivato"
    override val kitchen="Cucina"
    override val restaurant="Ristorante"
    override val prices="Prezzi"
    override val discount="Sconto"
    override val product="Prodotto"
    override val slash="/"
    override val noDiscountPossible="Articoli netti cliente (nessuno sconto possibile)"
    override val employeeNetItems="Articoli netti dipendente"
    override val employeeConsumption="Consumo dipendente"
    override val interimFinancialStatement="Rendiconto Finanziario Intermedio"
    override val enableUsersOnlyForTimeTracking="Abilita Utenti Solo Per Tracciamento Tempo"
    override val allReceipts="Tutte le Ricevute"
    override val noAuthorization="Nessuna Autorizzazione"
    override val onlyOwnReceipts="Solo Proprie Ricevute"
    override val gastronomy="Gastronomia"
    override val shortName="Nome Breve"
    override val addNewUser="Aggiungi nuovo utente"
    override val addNewCategory="Aggiungi nuova categoria"
    override val img="Immagine"
    override val menuCard="Menu"
    override val remove="Rimuovi"
    override val confirm="Conferma"
    override val cancel="Annulla"
    override val printName="Nome Stampa"
    override val users="Utenti"
    override val articleList="Lista Articoli"
    override val operation="Operazione"
    override val general="Generale"
    override val userPhoto="Foto Utente"
    override val title="Titolo"
    override val filter="Filtro"
    override val fibuNormal="Fibu Normale"
    override val financialReduced="Ridotto"
    override val accounting="Contabilità"
    override val accountingPercent="Contabilità 0%"
    override val article="Articolo"
    override val template="Modello"
    override val options="Opzioni"
    override val salesGroups="Gruppi Vendita"
    override val clickAndCollect="Clicca&Ritira"
    override val update="Aggiorna"
    override val DAYS_END="Fine Giornata"
    override val ADMINISTRATOR="Amministratore"
    override val MANAGER="Manager (Il manager può accedere ad altri utenti)"
    override val NO_SALES_TRIGGER="Nessun Trigger Vendite (Casa)"
    override val cancellationRight="Diritti di Cancellazione"
    override val receiptName="Nome Ricevuta"
    override val password="Password"
    override val name="Nome"
    override val waitersCastle="Castello Camerieri"
    override val right="Diritto"
    override val devices="Dispositivi"
    override val user="Utente"
    override val search="Cerca"
    override val number="Numero"
    override val language="Lingua"
    override val street="Via"
    override val label="Etichetta"
    override val companyName="Nome Azienda"
    override val zip="CAP"
    override val city="Città"
    override val APP_NAME_PART1="RunMy"
    override val APP_NAME_PART2="Setup"
    override val saturday = "Sa"
    override val sunday = "Do"
    override val monday = "Lu"
    override val tuesday = "Ma"
    override val wednesday = "Me"
    override val thursday = "Gi"
    override val friday = "Ve"
    override val USER_NAME="Jens Lehman"
    override val COMPANY_NAME="HS-Soft AG"
    override val forgetYourPassword="Password dimenticata?"
    override val login="Accedi"
    override val enterYourPassword="Password *"
    override val enterYourEmail="Inserisci email *"
    override val status="Stato"
    override val spent="Speso"
    override val sec="sec"
    override val steps="Passi"
    override val step="Passo"
    override val model="Modello"
    override val tokens="Token"
    override val expertMode="Modalità esperto"
    override val arguments="Argomenti"
    override val typeOrUseVoice="Inizia a digitare o usa la voce"
    override val availableToDownloadUntil="Disponibile per il download fino al"
    override val dataAssistantWelcomeMessage="Ciao! Come posso aiutarti?"
    override val kuchen="Cucina"
    override val buffet="Buffet"
    override val downloadExpired="Download scaduto"
    override val receiptPrinterSettings="Stampante ricevute"
    override val printerType="Tipo stampante"
    override val printerConnectionTarget="Numero seriale / Indirizzo IP"
    override val kitchenSettings="Impostazioni cucina"
    override val rooms="Sale"
    override val separateKitchenReport = "Rapporto di cucina separato"
    override val kitchenStationAnnounce = "Annuncio stazione di cucina"
    override val snOfKds = "Numero di serie KDS"
    override val companyNameEmptyHint="Un nome azienda vuoto può causare errori nel tuo sito"
    override val forgetPassInfo: String = "Il codice di verifica per reimpostare la password verrà inviato a questa email."
    override val forgetPassInfo2: String = "Inserisci il codice di verifica che è stato inviato alla tua email e imposta la tua nuova password."
    override val sendCode: String = "Invia codice"
    override val verificationCode: String = "Codice di verifica*"
    override val newPassword: String = "Nuova password*"
    override val confirmPassword: String = "Conferma password*"
    override val enterNewPassword: String = "Inserisci nuova password"
    override val enterNewPasswordAgain: String = "Inserisci nuovamente la password"
    override val updatePassword: String = "Aggiorna password"
    override val passwordRequirements: String = "Requisiti password"
    override val passwordReqLength: String = "Almeno 8 caratteri"
    override val passwordReqLower: String = "Almeno una lettera minuscola"
    override val passwordReqUpper: String = "Almeno una lettera maiuscola"
    override val passwordReqNumber: String = "Almeno un numero"
    override val passwordReqSpecial: String = "Almeno un carattere speciale"

    override val enterProductNumber: String = "Inserisci numero prodotto"
    override val enterProductName: String = "Inserisci nome prodotto"
    override val enterMediaNumber: String = "Inserisci numero media"
    override val enterMediaName: String = "Inserisci nome media"
    override val enterSaleGroupName: String = "Inserisci nome gruppo vendita"
    override val enterSaleGroupNumber: String = "Inserisci numero gruppo vendita"
    override val enterCategoryName: String = "Inserisci nome categoria"
    override val enterCategoryNumber: String = "Inserisci numero categoria"
    override val enterUserName: String = "Inserisci nome utente"
    override val enterUserNumber: String = "Inserisci numero utente"
    override val enterLocationName: String = "Inserisci nome posizione"
    override val enterLocationNumber: String = "Inserisci numero posizione"
    override val printEFTReceipt: String = "Stampa ricevuta EFT"
    override val addNewAlergene: String = "Aggiungi nuovo allergene"
    override val takeOver: String = "Assumere"
    override val createCustomeAlergene: String = "Crea allergene personalizzato"
    override val keyword: String = "Parola chiave"
    override val unit: String = "Unità"
    override val nutritionalValues: String = "Valori nutrizionali"
    override val type = "Tipo"
    override val startDate = "Data di inizio"
    override val endDate = "Data di fine"
    override val startTime = "Ora di inizio"
    override val lambda_seconds = "Secondi di utilizzo Lambda"
    override val data_size_kbytes = "Dimensione dati KB"
    override val is_premium = "È Premium"
    override val file_count = "Numero di file"
    override val freeCredits = "Crediti gratuiti"
    override val premiumCredits = "Crediti premium"
    override val freeCreditsInfo = "Utilizzati per domande e operazioni di base. Questi crediti si rinnovano ogni mese e non possono essere acquistati."
    override val premiumCreditsInfo = "Utilizzati per analisi avanzate e funzionalità AI. Acquista altri crediti secondo necessità. Questi crediti non scadono."
    override val creditsWarning = "stanno per finire"
    override val learnMore = "Scopri di più"
    override val topUpCredits = "Ricarica crediti"
    override val info = "Info"
    override val favorites = "Preferiti"
}